import React from 'react';
import { CTASection } from '../components/CTASection';
import { motion } from 'framer-motion';
export function About() {
  return <main className="pt-24" data-id="element-385">
      <section className="py-20 bg-white" data-id="element-386">
        <div className="container mx-auto px-4 md:px-6" data-id="element-387">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-388">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.5
          }} data-id="element-389">
              <h1 className="text-4xl md:text-5xl font-heading font-extrabold text-navy mb-6" data-id="element-390">
                About Global Remote
              </h1>
              <p className="text-lg text-muted mb-6 leading-relaxed" data-id="element-391">
                We are a dedicated team of local SEO experts, developers, and
                digital marketers passionate about helping local businesses
                thrive in their communities.
              </p>
              <p className="text-lg text-muted mb-6 leading-relaxed" data-id="element-392">
                As a proud member of the MacAnthony Group of Companies, we bring
                enterprise-level strategies to local businesses, ensuring you
                get found, trusted, and chosen by customers in your area.
              </p>
              <div className="bg-surface p-6 rounded-xl border border-gray-100" data-id="element-393">
                <h3 className="font-heading font-bold text-navy text-xl mb-2" data-id="element-394">
                  Our Mission
                </h3>
                <p className="text-muted" data-id="element-395">
                  To empower local businesses with the tools and strategies they
                  need to build an unbeatable online reputation and dominate
                  local search.
                </p>
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="relative h-[500px] rounded-2xl overflow-hidden shadow-2xl" data-id="element-396">
              <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=1600&q=80" alt="Team collaborating" className="w-full h-full object-cover" data-id="element-397" />
            </motion.div>
          </div>
        </div>
      </section>
      <CTASection data-id="element-398" />
    </main>;
}